import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import ConsentBanner from "@/components/ConsentBanner";
import { trackEvent } from "@/lib/api";
import Home from "@/pages/Home";
import Product from "@/pages/Product";
import Compare from "@/pages/Compare";
import HowItWorks from "@/pages/HowItWorks";
import Pilot from "@/pages/Pilot";
import Platform from "@/pages/Platform";
import UseCases from "@/pages/UseCases";
import UseCaseDetail from "@/pages/UseCaseDetail";
import RequestPilot from "@/pages/RequestPilot";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import Article from "@/pages/Article";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";

function RouteEffects() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent("page_view", { path: location.pathname });
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteEffects />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gnts1-bluetooth-smart-sticker" element={<Product productId="gnts1" />} />
            <Route path="/ll100-4g-smart-label" element={<Product productId="ll100" />} />
            <Route path="/compare-smart-labels" element={<Compare />} />
            <Route path="/how-smart-labels-work" element={<HowItWorks />} />
            <Route path="/smart-label-pilot" element={<Pilot />} />
            <Route path="/goandtrack-platform" element={<Platform />} />
            <Route path="/use-cases" element={<UseCases />} />
            <Route path="/use-cases/:slug" element={<UseCaseDetail />} />
            <Route path="/request-a-pilot" element={<RequestPilot />} />
            <Route path="/about" element={<About />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<Article />} />
            <Route path="/privacy" element={<Legal page="privacy" />} />
            <Route path="/cookies" element={<Legal page="cookies" />} />
            <Route path="/terms" element={<Legal page="terms" />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <ConsentBanner />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
